import { Text } from '@zillow/constellation-10';

import { StyledHR } from '../postingPath/UtilsStyledComponents';

import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

const DuplicateListingDetailsContainer = ({ children }: Props) => (
  <div data-testid="DuplicateListingDetails">
    <Text asChild textStyle="heading-sm" css={{ marginBottom: { base: '200', lg: '400' } }}>
      <p>Additional listing sources</p>
    </Text>
    {children}
    <StyledHR marginY="md" marginX={0} />
  </div>
);

export default DuplicateListingDetailsContainer;
